import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Typography } from 'mobily-ui-library/lib';
import { GlobalContext } from '../../../context/GlobalContext';

import { applyPromotion, overrideSCInstallment, instalmentPatch } from '../../../api/api'; 4
import HeaderNavigation from '../HeaderNavigation/HeaderNavigation';

import './DeviceTerms.scss';

interface Props {
    handleHeaderCancel: () => void;
}

const win: any = window;
const serverURL = win['base_portal_url'];
const errorPage = win['errorPageURL'];

function DeviceTerms({ handleHeaderCancel }: Props) {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, scData, cartId, lang, promotionType, productId, promotionApplied, deviceFlow, appliedInstallment } = state;

    const { t } = useTranslation();

    const [checked, setChecked] = useState(false);
    const [htmlData, setHTMLData] = useState<any>(null);

    const wajidName = promotionApplied?.name ? promotionApplied?.name.replaceAll(' ', '+') : '';
    const promotionName = promotionType === 'Raqi' ? promotionApplied?.name : wajidName; 
    const cartItemId = scData?.offerContainer[0]?.cartItem[0]?.id ? scData?.offerContainer[0]?.cartItem[0]?.id : "";
    const itemPriceId = scData?.offerContainer[0]?.cartItem[0]?.itemPrice[0]?.priceId;
    const ocId = scData?.offerContainer[0]?.id
    
    //"Device_Subsidy_3600" ---> Raqi
    //Wajid Extra Subsidy // Wajid+Extra+Subsidy

    useEffect(() => {
        if(deviceFlow === 'subsidy') {
            const url = `${serverURL}/web/${lang}/devices/terms-and-conditions/subsidy/${promotionName}`;
            dispatch({ type: "LOADER", payload: { loading: true } });
    
            fetch(url)
                .then((res) => {
                    return res.text()
                }).then(data => {
                    setHTMLData(data)
                    dispatch({ type: "LOADER", payload: { loading: false } });
                })
        } else {
            const url = `${serverURL}/web/${lang}/devices/terms-and-conditions/installment`;

            fetch(url)
            .then((res) => {
                return res.text()
            }).then(data => {
                setHTMLData(data)
                setTimeout(() => {
                    const monthlyInstalment: any = document.getElementById('monthly_installment');
                    const upfrontPayment: any = document.getElementById('upfront_payment');

                    monthlyInstalment.innerHTML = appliedInstallment?.MonthlyCommitmentAmt;
                    upfrontPayment.innerHTML = appliedInstallment?.PromotionCommitmentPeriod;
                }, 0)
            })
        }
    }, [])

    const handleCheckbox = () => {
        setChecked(prevState => !prevState)
    }

    const handleBackArrow = () => {
        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: 'deviceClaimPlan' } })
    }

    const handleApplySubsidy = () => {
        const req = {
            shoppingCartData: {
                ocId: scData.offerContainer[0]?.id,
                scId: cartId
            },
            promotionData: {
                packageId: productId,
                promotionId: promotionApplied?.id,
                signature: promotionApplied?.signature
            }
        }
        dispatch({ type: "LOADER", payload: { loading: true } });

        if(deviceFlow === 'subsidy') {
            applyPromotion(req.shoppingCartData, req.promotionData)
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: 'deviceSubsidySuccess' } })
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
                }
            }).catch(err => {
                window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
            })
        } else {
            instalmentPatchAPI()
        }
    }

    const instalmentPatchAPI = () => {
        instalmentPatch(scData?.id, ocId, appliedInstallment?.MonthlyCommitmentAmt, appliedInstallment?.PromotionCommitmentPeriod, appliedInstallment?.PromotionTechnicalName)
        .then((res: any) => {
            if (res?.status === 201 && res?.data) {
                instalmentPromotionApplyAPI()
            } else {
                dispatch({ type: "LOADER", payload: { loading: false } });
                window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
            }
        }).catch(err => {
            window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
        })
    }

    const instalmentPromotionApplyAPI = () => {
        overrideSCInstallment(scData?.id, cartItemId, itemPriceId, ocId)
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: 'deviceSubsidySuccess' } })
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
                }
            }).catch(err => {
                window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
            })
    }

    return (
        <div className='DeviceTermsNCondition__Container'>
            <HeaderNavigation
                rtl={rtl}
                percent={100}
                showBackArrow={true}
                handleBackArrow={handleBackArrow}
                handleHeaderCancel={handleHeaderCancel}
            />

            <div className='DeviceTnC__Content' dangerouslySetInnerHTML={{ __html: htmlData ? htmlData : '' }}></div>

            {/* sticky terms n condition */}
            <div className='DTNC__StickyBox'>
                <div className='STB__Container'>
                    <div className='STB__TnC'>
                        <input aria-label='checkbox' type='checkbox' onChange={handleCheckbox} className='STB__Checkbox' />
                        <Typography rtl={rtl} id="lineType-heading" className='STB__Text'>{deviceFlow === 'subsidy' ? t('Accept_TermsNcondition') : t('installments_terms_conditions')}</Typography>
                    </div>
                    <Button
                        rtl={rtl}
                        className= {`STB__ApplyBtn ApplyBtn_${deviceFlow === 'subsidy' ? 'sub' : 'inst'}`}
                        variant={!checked ? 'disabled' : 'default'}
                        onClick={handleApplySubsidy}
                    >
                        {deviceFlow === 'subsidy' ? t('Apply_Subsidy') : t('apply_installments')}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default DeviceTerms